import AxiosConfig from '../utils/AxiosConfig';

class SupplierBillingStatementService {
  
  // Obtener todos los estados de cuenta de proveedores
  async getSupplierBillingStatements(page = 1, pageSize = 10, supplierId = null, status = null) {
    try {
      const params = new URLSearchParams();
      params.append('page', page);
      params.append('pageSize', pageSize);
      if (supplierId) params.append('supplierId', supplierId);
      if (status) params.append('status', status);
      
      const response = await AxiosConfig.get(`/providers/billing-statements?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier billing statements:', error);
      throw error;
    }
  }

  // Obtener detalles de un estado de cuenta específico
  async getSupplierBillingStatementById(supplierId) {
    try {
      const response = await AxiosConfig.get(`/providers/billing-statements/${supplierId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier billing statement:', error);
      throw error;
    }
  }

  // Reposiciones de un proveedor, paginadas en el backend
  async getSupplierReplenishments(supplierId, page = 1, pageSize = 10, onlyPending = false) {
    try {
      const params = new URLSearchParams({ page, pageSize, onlyPending });
      const response = await AxiosConfig.get(`/providers/billing-statements/${supplierId}/replenishments?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier replenishments:', error);
      throw error;
    }
  }

  // Detalle completo de una reposición del estado de cuenta (alcance del estado de cuenta, no del módulo de reposiciones).
  // La factura viene con URL firmada de corta duración.
  async getSupplierReplenishmentDetail(supplierId, replenishmentId) {
    try {
      const response = await AxiosConfig.get(
        `/providers/billing-statements/${supplierId}/replenishments/${replenishmentId}`,
        { skipGlobalErrorRedirect: true }
      );
      return response.data.data;
    } catch (error) {
      console.error('Error fetching supplier replenishment detail:', error);
      throw error;
    }
  }

  // Registrar un pago al proveedor repartido entre las facturas elegidas
  async registerSupplierPayment(supplierId, payment) {
    try {
      const response = await AxiosConfig.post(`/providers/billing-statements/${supplierId}/payments`, payment);
      return response.data;
    } catch (error) {
      console.error('Error registering supplier payment:', error);
      throw error;
    }
  }

  // Movimientos (facturas y pagos) con saldo acumulado, paginados en el backend
  async getSupplierMovements(supplierId, page = 1, pageSize = 20) {
    try {
      const params = new URLSearchParams({ page, pageSize });
      const response = await AxiosConfig.get(`/providers/billing-statements/${supplierId}/movements?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching supplier movements:', error);
      throw error;
    }
  }

  // Obtener color del estado
  getStatusColor(status) {
    switch (status) {
      case 'UP_TO_DATE':
        return 'success';
      case 'PENDING_DEBT':
        return 'warning';
      case 'OVERDUE_DEBT':
        return 'error';
      default:
        return 'default';
    }
  }

  // Obtener texto del estado
  getStatusText(status, t) {
    switch (status) {
      case 'UP_TO_DATE':
        return t('up_to_date') || 'Al día';
      case 'PENDING_DEBT':
        return t('pending_debt') || 'Deuda pendiente';
      case 'OVERDUE_DEBT':
        return t('overdue_debt') || 'Deuda vencida';
      default:
        return status;
    }
  }
}

export default new SupplierBillingStatementService();
